import { ChartBinSize, ChartDefinition, ChartGroupByMode, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';

import { STOCK_VOLUME_CHART_ENDPOINT } from '../stock-chart-endpoints';

export const STOCK_VOLUME_BY_PRODUCT_LIST_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.STOCK_VOLUME_BY_PRODUCT_LIST,
    chartType: ChartRendererType.LIST,
    endpoint: STOCK_VOLUME_CHART_ENDPOINT,
    filters: [{ key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.FULL_PERIOD }],
    groupBy: ChartQueryParam.PRODUCT_ID,
    groupByMode: ChartGroupByMode.VALUE
};
